import React from "react";
import { MessageSquare } from "lucide-react";

export function EmptyConversationsState() {
  return (
    <div className="flex-1 flex items-center justify-center p-4">
      <div className="text-center">
        <MessageSquare className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <h3 className="text-sm font-medium text-foreground mb-1">No conversations yet</h3>
        <p className="text-xs text-muted-foreground">
          Start a new conversation to get started
        </p>
      </div>
    </div>
  );
}